import React from 'react'

const ChevronLeft = ({ width = '20px', height = '20px', ...rest }) => (
  <svg viewBox="0 0 20 20" width={width} height={height} {...rest}>
    <path d="M13.2 5.7l-1.4-1.4L6.1 10l5.7 5.7 1.4-1.4L8.9 10z" />
  </svg>
)

export default ChevronLeft
